import { useContext } from 'react';
import { CashFlowContext } from '../context/CashFlowContext';

const useCashFlowContext = () => useContext(CashFlowContext);

export default useCashFlowContext;
